// <head> metadata for NotFoundPage.
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Page Not Found | DBOS',
    },
    {
      property: 'og:title',
      content: 'Page Not Found | DBOS',
    },
    {
      name: 'twitter:title',
      content: 'Page Not Found | DBOS',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/404',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
